/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Box from 'relements/build/esm/ui/box';

import InviteYourFriend from '@src/containers/InviteYourFriend';

const ContainerStyle = ({ theme }) => ({
  width: '40%', // This is calculated from the design
  flexDirection: 'column',
  borderLeft: `1px solid ${theme.colors.grey.haptik}`,
  height: 'calc(100vh - 40px)',
  padding: theme.space.zero,
  backgroundColor: theme.colors.background,
});
export const Container = styled(Box)(ContainerStyle);

const HelpSection = ({ children, description }) => {
  return (
    <Container>
      <Box padding="20px">
        <InviteYourFriend description={description} />
      </Box>
      {children}
    </Container>
  );
};

HelpSection.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.node,
};

HelpSection.defaultProps = {
  children: null,
};

export default React.memo(HelpSection);
